import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { successSchema } from '../utils';
import { ZEmailBlocklistRequest } from './models';

const c = initContract();

export const adminModerationContract = c.router(
  {
    getBlocklistEmail: {
      method: 'GET',
      path: '/get-blocklist-email',
      query: ZEmailBlocklistRequest,
      responses: {
        200: z.object({
          isBlocked: z.boolean(),
        }),
      },
      summary: 'Check if an email is blocklisted',
    },
    addEmailToBlocklist: {
      method: 'POST',
      path: '/add-email-to-blocklist',
      body: ZEmailBlocklistRequest,
      responses: {
        200: successSchema,
      },
      summary: 'Add email to blocklist',
    },
    removeEmailFromBlocklist: {
      method: 'DELETE',
      path: '/remove-email-from-blocklist',
      body: ZEmailBlocklistRequest,
      responses: {
        200: successSchema,
      },
      summary: 'Remove email from blocklist',
    },
  },
  {
    pathPrefix: '/admin',
    strictStatusCodes: true,
    baseHeaders: z.object({
      'x-access-token': z.string(),
    }),
    commonResponses: {
      401: c.type<{ message: string; statusCode: 401 }>(),
      403: c.type<{ message: string; statusCode: 403 }>(),
    },
  },
);
